<template>
    <div class="document-upload__container">
        <div class="document-upload__wrapper">
            <GenericForm
                :asyncErrors="asyncErrors"
                :fields="fields"
                @submit="onSubmit"
            >
                <template slot-scope="slotProps">
                    <div class="instruction">
                        {{ $t('Upload or take a color photo of your identity card. After the successful ' +
                            'upload, we will check if everything is correct, and we will send you the confirmation ' +
                            'or the next steps to complete the verification process') }}
                    </div>
                    <div class="form-content">
                        <CustomFileInput
                            :allowDragAndDrop="true"
                            :dropAreaLabel="'drag and drop the image here'"
                            name="file"
                            v-model="fields.file.value"
                            :errorMessage="slotProps.errors.file"
                            @valueChanged="slotProps.onValueChanged"
                            accept="image/*"
                        />
                    </div>
                    <div class="upload-footer">
                        <div class="file-size-warning">
                            {{ $t('file size is limited to') | capitalize }}
                            <span class="max-size">
                                {{ humanReadableMaxFileSize }}.
                            </span>
                            {{ $t('only images are allowed') | capitalize }}!
                        </div>
                        <div
                            class="action-text"
                            @click="showHelp"
                        >
                            {{ $t('help') | capitalize }}
                        </div>
                    </div>
                    <div
                        v-if="error"
                        class="message message--error-big"
                    >
                        {{ $t('Something went wrong. Please try again') | capitalize }}
                    </div>
                    <div>
                        <CustomButton
                            :isLoading="isLoading"
                            type="submit"
                            class="btn btn--lg btn__primary btn-block btn--w-144"
                        >
                            <template v-if="error">
                                {{ $t('retry') | capitalize }}
                            </template>
                            <template v-else>
                                {{ $t('submit for verification') | upperCase }}
                            </template>
                        </CustomButton>
                    </div>
                </template>
            </GenericForm>
        </div>
    </div>
</template>

<script>
    import config from '@config';
    import { isRequired, maxFileSize, allowedFormatsByFilename } from '@modules/shared/validators/forms';
    import UserService from '@core/services/user/UserService';
    import { Logger } from '@core/utils/loggers/Logger';
    import { errorGuard } from '@app/utils';
    import ValidationError from '@core/errors/network/ValidationError';
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                isLoading: false,
                error: '',
                asyncErrors: {},
                fields: {
                    file: {
                        value: null,
                        validate: [
                            isRequired,
                            maxFileSize(
                                config.app.user.idCardVerification.fileSize,
                                config.app.user.idCardVerification.fileSizeHumanReadable
                            ),
                            allowedFormatsByFilename(config.app.user.idCardVerification.allowedFormats)
                        ]
                    },
                },
            };
        },
        created() {
            this.humanReadableMaxFileSize = config.app.user.idCardVerification.fileSizeHumanReadable;
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            onSubmit() {
                this.isLoading = true;
                this.error = '';

                const file = this.fields.file.value[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = async () => {
                    await errorGuard({
                        action: async () => {
                            await UserService.getInstance().uploadIdCard(reader.result, file.name);
                            this.$emit('success');
                        },
                        onError: (e) => {
                            if (e instanceof ValidationError) {
                                this.asyncErrors = e.fieldErrors;
                            } else {
                                this.error = this.$t('Something went wrong. Please try again');
                                this.$emit('error', e);
                            }
                        },
                        showGlobalError: false,
                    });
                    this.isLoading = false;
                };
                reader.onerror = (e) => {
                    this.isLoading = false;
                    this.error = this.$t('Something went wrong. Please try again');
                    Logger.error(e);
                };
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/documentUpload/components/DocumentUploadForm.vue